import { Button, CheckboxFormField, ClassName, Form, IFormRender, Theme } from '@busybusy/webapp-react-ui';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { useToastDispatch } from 'contexts/ToastContext';
import { usePositionUpdate } from 'hooks';
import { t } from 'i18next';
import IPosition from 'types/Position';

export interface IRequireDescriptionSettingsFormProps {
  className?: ClassName;
  position: IPosition;
  onSubmit: (data: { enabled: boolean }) => void;
}

export interface IRequireDescriptionSettingsFormData {
  enabled: boolean;
}

export const RequireDescriptionSettingsForm = (props: IRequireDescriptionSettingsFormProps) => {
  const { className, position, onSubmit } = props;

  const [, update] = usePositionUpdate();
  const toastDispatch = useToastDispatch();

  async function onFormSubmit(data: IRequireDescriptionSettingsFormData) {
    try {
      await update({
        id: position.id,
        requireTimeEntryDescription: data.enabled,
      });
    } catch (e) {
      toastDispatch({
        type: 'OPEN',
        payload: {
          theme: Theme.DANGER,
          label: t('There was a problem updating your position. Please try again later.'),
        },
      });
    }

    onSubmit(data);
  }

  function renderFormFields(form: IFormRender<IRequireDescriptionSettingsFormData>) {
    return (
      <>
        <CheckboxFormField
          key={'enabled'}
          name={'enabled'}
          form={form}
          label={
            <HeaderText title={t('Require Description')}>
              <span>
                {t(
                  'When clocking their own time, require employees to have a description on their time entry before switching or clocking out.'
                )}
              </span>
            </HeaderText>
          }
        />
        <Button type="primary" onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }

  return (
    <Form
      className={className}
      render={renderFormFields}
      onSubmit={onFormSubmit}
      data={{ enabled: !!position.requireTimeEntryDescription }}
      allowMultipleSubmissions={true}
    />
  );
};
